import { produce } from 'immer'
// import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'
import {
  DELETE_USERS_ORG_INTEGRATION_LOGIN_FAILURE,
  DELETE_USERS_ORG_INTEGRATION_LOGIN_INIT,
  DELETE_USERS_ORG_INTEGRATION_LOGIN_SUCCESS,
  DeleteUsersOrgIntegrationLoginActions,
  MANAGE_ORG_INTEGRATION_ADD_ACCOUNT_FAILURE,
  MANAGE_ORG_INTEGRATION_ADD_ACCOUNT_INIT,
  MANAGE_ORG_INTEGRATION_ADD_ACCOUNT_SUCCESS,
  MANAGE_ORG_INTEGRATION_GET_ACCOUNTS_FAILURE,
  MANAGE_ORG_INTEGRATION_GET_ACCOUNTS_INIT,
  MANAGE_ORG_INTEGRATION_GET_ACCOUNTS_SUCCESS,
  MANAGE_ORG_INTEGRATION_GET_STATUS_FAILURE,
  MANAGE_ORG_INTEGRATION_GET_STATUS_INIT,
  MANAGE_ORG_INTEGRATION_GET_STATUS_SUCCESS,
  ManageOrgIntegrationAddAccountActions,
  ManageOrgIntegrationGetAccountsActions,
  ManageOrgIntegrationGetStatusActions,
} from 'src/app/ManageOrgIntegration/redux/manageOrgIntegrationPopup.actions'
// import { OrgIntegration } from 'src/app/Integrations/Integrations'
import { BankAccountListResponse } from 'src/models/bankAccount.models'
import { OrganizationIntegrationListResponse } from 'src/models/organizationIntegration.models'
import { TaxRateListResponse } from 'src/models/taxRate.models'
import { manageOrgIntegrationRouteProps } from 'src/navigation/routeProps'
import {
  GET_ORG_INTEGRATION_FAILURE,
  GET_ORG_INTEGRATION_INIT,
  GET_ORG_INTEGRATION_SUCCESS,
  GetOrgIntegrationActions,
} from 'src/queries/organizations/integrations/integrations.actions'
import CreditCardsFullPaginatedDataReducer, {
  Actions as CreditCardsFullPaginatedDataActions,
  CreditCardsFullPaginatedDataState,
  initialState as initialCreditCardsFullPaginatedDataState,
} from 'src/redux/creditCardsFullPaginatedData.reducer'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { parseBackendErrors } from 'src/utils/error.utils'

export type BaseManageOrganizationState = {
  orgIntegration: OrganizationIntegrationListResponse | undefined
  loadingOrgIntegration: boolean
  bankAccounts?: BankAccountListResponse[]
  taxRates?: Record<string, TaxRateListResponse>
  isDeletingOrgIntegration: boolean
  isAddingOrgIntegrationAccount: boolean
  loading: boolean
  topLevelError?: string

  // TO DO: Need to set these up for error states
  // topLevelError?: string
  // errorDetailMap?: ErrorDetailMap<string>
}
export const initialBaseState: BaseManageOrganizationState = {
  isDeletingOrgIntegration: false,
  isAddingOrgIntegrationAccount: false,
  loading: false,
  bankAccounts: undefined,
  taxRates: undefined,
  orgIntegration: undefined,
  loadingOrgIntegration: false,
  topLevelError: undefined,
}

export type BaseActions =
  | ManageOrgIntegrationGetAccountsActions
  | ManageOrgIntegrationAddAccountActions
  | DeleteUsersOrgIntegrationLoginActions
  | ManageOrgIntegrationGetStatusActions
  | GetOrgIntegrationActions

const BaseManageOrganizationReducer = (
  state = initialBaseState,
  action: BaseActions,
): BaseManageOrganizationState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case MANAGE_ORG_INTEGRATION_GET_ACCOUNTS_INIT: {
        draft.loading = true
        return draft
      }

      case MANAGE_ORG_INTEGRATION_GET_ACCOUNTS_SUCCESS: {
        draft.bankAccounts = action.payload.bankAccounts
        draft.taxRates = action.payload.taxRates
        draft.loading = false
        return draft
      }

      case MANAGE_ORG_INTEGRATION_GET_ACCOUNTS_FAILURE: {
        draft.loading = false
        // const errors = parseBackendErrors(action.payload)
        // draft.topLevelError = errors.topLevelError
        // draft.errorDetailMap = errors.errorDetailMap
        return draft
      }

      case DELETE_USERS_ORG_INTEGRATION_LOGIN_INIT: {
        draft.isDeletingOrgIntegration = true
        draft.topLevelError = undefined
        // draft.errorDetailMap = undefined
        return draft
      }

      case DELETE_USERS_ORG_INTEGRATION_LOGIN_SUCCESS: {
        draft.isDeletingOrgIntegration = false
        return draft
      }

      case DELETE_USERS_ORG_INTEGRATION_LOGIN_FAILURE: {
        draft.isDeletingOrgIntegration = false
        // const errors = parseBackendErrors(action.payload)
        // draft.topLevelError = errors.topLevelError
        // draft.errorDetailMap = errors.errorDetailMap
        return draft
      }

      case MANAGE_ORG_INTEGRATION_ADD_ACCOUNT_INIT: {
        draft.isAddingOrgIntegrationAccount = true
        draft.topLevelError = undefined
        // draft.errorDetailMap = undefined
        return draft
      }

      case MANAGE_ORG_INTEGRATION_ADD_ACCOUNT_SUCCESS: {
        draft.isAddingOrgIntegrationAccount = false
        return draft
      }

      case MANAGE_ORG_INTEGRATION_ADD_ACCOUNT_FAILURE: {
        draft.isAddingOrgIntegrationAccount = false
        const errors = parseBackendErrors(action.payload)
        if (
          errors.topLevelError?.includes('The supplier is not valid') ||
          errors.topLevelError?.includes('The customer is not valid')
        ) {
          draft.topLevelError =
            'There was an unexpected issue with your connection. Please cancel connection and try to reconnect.'
        } else {
          draft.topLevelError =
            'There was an unexpected issue with your connection.'
        }
        return draft
      }

      case MANAGE_ORG_INTEGRATION_GET_STATUS_INIT: {
        draft.topLevelError = undefined
        return draft
      }
      case MANAGE_ORG_INTEGRATION_GET_STATUS_SUCCESS: {
        draft.orgIntegration = {
          ...draft.orgIntegration,
          connectionStatus: action.payload.status,
        } as OrganizationIntegrationListResponse
        draft.loadingOrgIntegration = false
        return draft
      }
      case MANAGE_ORG_INTEGRATION_GET_STATUS_FAILURE: {
        // do nothing for now
        return draft
      }

      case GET_ORG_INTEGRATION_INIT: {
        draft.loadingOrgIntegration = true
        draft.topLevelError = undefined
        return draft
      }
      case GET_ORG_INTEGRATION_SUCCESS: {
        draft.orgIntegration = action.payload.organizationConnection
        draft.loadingOrgIntegration = false
        return draft
      }
      case GET_ORG_INTEGRATION_FAILURE: {
        const { topLevelError } = parseBackendErrors(action.payload)

        draft.loadingOrgIntegration = false
        draft.topLevelError = topLevelError
        return draft
      }
    }
  })
}

export type Actions = CreditCardsFullPaginatedDataActions | BaseActions

export type ManageOrgIntegrationState = BaseManageOrganizationState & {
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataState
}

export const initialState: ManageOrgIntegrationState = {
  ...initialBaseState,
  creditCardsFullPaginatedData: initialCreditCardsFullPaginatedDataState,
}

const CoreManageOrgIntegrationReducer = (
  state = initialState,
  action: Actions,
): ManageOrgIntegrationState => ({
  ...BaseManageOrganizationReducer(state, action as BaseActions),
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataReducer(
    state.creditCardsFullPaginatedData,
    action as CreditCardsFullPaginatedDataActions,
  ),
})

const ManageOrgIntegrationReducer = createFlyoutReducer(
  manageOrgIntegrationRouteProps,
  initialState,
  CoreManageOrgIntegrationReducer,
)

export default ManageOrgIntegrationReducer
